export default "__VITE_ASSET__C1YZ1vBW__"